import moment from 'moment';
import 'moment/locale/ja';

moment.locale('ja');

export default moment;
